module.exports = __webpack_public_path__ + "static/media/nutriguideMobileMock.7d2935a3.webp";